<app-header></app-header>

<div class="flex mt-2">
    <app-sidebar optionMenu="7"></app-sidebar>

    <div class="flex cursor-pointer h-full relative left-16 top-8" [routerLink]="['/ia']">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
            <path d="M8 15L1 8L8 1" stroke="#3C00A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="relative left-2 bottom-1">ATRÁS</p>
    </div>

    <div class="bg-white p-6 rounded-2xl relative h-full w-[70%] top-20">
        <h2 class="text-2xl font-bold mb-8">Sintetizador narrativo multiformato</h2>

        <div class="flex gap-10">

            <div class="w-72 flex flex-col">

                <label class="text-sm font-semibold mb-1">Formato</label>
                <select class="w-full p-3 border text-sm rounded-lg bg-[rgba(230,230,230,0.60)]" [(ngModel)]="formato">
                    <option value="guion-para-video-corto">Guion para video corto</option>
                    <option value="guion-para-video-largo">Guion para video largo</option>
                    <option value="carrusel-informativo-para-instagram">Carrusel informativo para Instagram</option>
                    <option value="post-para-linkedin">Post para LinkedIn</option>
                    <option value="post-para-facebook">Post para Facebook</option>
                    <option value="titulares-para-whatsapp">Titulares para WhatsApp</option>
                    <option value="trino-para-x">Trino para X</option>
                </select>

                <div class="h-6"></div>

                <label class="text-sm font-semibold mb-1">Tono</label>
                <select class="w-full p-3 border text-sm rounded-lg bg-[rgba(230,230,230,0.60)]" [(ngModel)]="tono">
                    <option value="serio">Serio</option>
                    <option value="explicativo">Explicativo</option>
                    <option value="emotivo">Emotivo</option>
                </select>

            </div>

            <div class="flex-1">

                <div class="flex items-center gap-4 mb-4">

                    <span class="text-sm font-bold cursor-pointer transition" (click)="isLinkMode = false"
                        [class.text-[#5A0FC8]]="!isLinkMode" [class.text-gray-500]="isLinkMode">
                        Ingresa Texto
                    </span>

                    <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" class="sr-only peer" [(ngModel)]="isLinkMode">

                        <div class="w-10 h-5 bg-gray-300 rounded-full transition-all"></div>

                        <div
                            class="absolute left-1 top-1 w-3.5 h-3.5 bg-white rounded-full transition-all peer-checked:translate-x-5 shadow">
                        </div>
                    </label>

                    <span class="text-sm font-bold cursor-pointer transition" (click)="isLinkMode = true"
                        [class.text-[#5A0FC8]]="isLinkMode" [class.text-gray-500]="!isLinkMode">
                        Ingresa Link
                    </span>

                </div>

                <textarea *ngIf="!isLinkMode" [(ngModel)]="texto"
                    class="w-full h-44 bg-[#eef2f1] rounded-md p-4 text-sm outline-none resize-none"
                    placeholder="Escribe o pega el texto aquí..."></textarea>

                <input *ngIf="isLinkMode" [(ngModel)]="link" type="text"
                    class="w-full h-12 bg-[#eef2f1] rounded-md p-3 text-sm outline-none"
                    placeholder="Pega el enlace aquí...">

            </div>
        </div>

        <div class="flex justify-end">
            <button (click)="generar()"
                class="flex items-center gap-2 bg-[#3C00A3] text-white px-6 py-3 mt-6 rounded-xl font-semibold text-sm">
                <span class="text-lg">+</span><p>Generar versión</p>
            </button>
        </div>
        

        <div *ngIf="resultado" class="mt-8 bg-gray-100 p-4 rounded-xl text-sm whitespace-pre-line">
            {{ resultado }}
        </div>

    </div>

    <div *ngIf="mostrarModal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

        <div class="relative bg-white w-[520px] max-h-[85vh] rounded-2xl p-10 shadow-xl text-center flex flex-col">

            <button (click)="cerrarModal(false)"
                class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl font-bold">
                ✕
            </button>

            <div class="flex justify-center mb-4 shrink-0">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none"> <circle cx="45" cy="45" r="43" stroke="#2AA987" stroke-width="4" /> <path d="M30 46L41 57L60 33" stroke="#2AA987" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
            </div>

            <h2 class="text-xl font-bold mb-4 shrink-0">VERSIÓN CREADA CON ÉXITO</h2>

            <div class="text-gray-700 text-sm leading-6 mb-8 whitespace-pre-line overflow-y-auto max-h-[45vh] px-1">
                {{ resultado }}
            </div>

            <div class="flex justify-center gap-4 shrink-0 mt-auto">

                <button (click)="copiar()"
                    class="flex w-[184px] h-[54px] p-[10px] justify-center items-center gap-[10px] rounded-[4px] bg-[#6E7881] text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none"> <path d="M6.66797 10.224C6.66797 9.28086 7.04262 8.37638 7.7095 7.7095C8.37638 7.04262 9.28086 6.66797 10.224 6.66797H21.7786C22.2456 6.66797 22.708 6.75995 23.1395 6.93865C23.5709 7.11736 23.9629 7.37929 24.2931 7.7095C24.6233 8.0397 24.8852 8.43171 25.064 8.86315C25.2427 9.29458 25.3346 9.75699 25.3346 10.224V21.7786C25.3346 22.2456 25.2427 22.708 25.064 23.1395C24.8852 23.5709 24.6233 23.9629 24.2931 24.2931C23.9629 24.6233 23.5709 24.8852 23.1395 25.064C22.708 25.2427 22.2456 25.3346 21.7786 25.3346H10.224C9.75699 25.3346 9.29458 25.2427 8.86315 25.064C8.43171 24.8852 8.0397 24.6233 7.7095 24.2931C7.37929 23.9629 7.11736 23.5709 6.93865 23.1395C6.75995 22.708 6.66797 22.2456 6.66797 21.7786V10.224Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" /> <path d="M2.68332 19.65C2.27398 19.4174 1.93352 19.0806 1.69652 18.6738C1.45952 18.2671 1.33444 17.8048 1.33398 17.334V4.00065C1.33398 2.53398 2.53398 1.33398 4.00065 1.33398H17.334C18.334 1.33398 18.878 1.84732 19.334 2.66732" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                    Copiar
                </button>

                <button (click)="cerrarModal(true)"
                    class="flex w-[184px] h-[54px] px-[10px] py-[4px] justify-center items-center rounded-[4px] bg-[#F20066] text-white">
                    Cancelar
                </button>

            </div>

        </div>
    </div>



</div>